"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
require("antd/lib/message/style");
var _message2 = _interopRequireDefault(require("antd/lib/message"));
var _react = _interopRequireWildcard(require("react"));
require("./style.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _login = require("../../servers/login");
var _login2 = require("../../consts/login");
var _consts = require("../../consts");
var _Captcha = _interopRequireDefault(require("../Captcha"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var MAX_LENGTH = 5;
var Index = function Index(props) {
  var sourceType = props.sourceType,
    id = props.id,
    bid = props.bid,
    disabled = props.disabled,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    _props$prefix = props.prefix,
    prefix = _props$prefix === void 0 ? false : _props$prefix,
    _props$typeMsg = props.typeMsg,
    typeMsg = _props$typeMsg === void 0 ? 'default' : _props$typeMsg,
    account = props.account,
    _props$messageParam = props.messageParam,
    messageParam = _props$messageParam === void 0 ? '' : _props$messageParam,
    className = props.className,
    onValid = props.onValid,
    onError = props.onError,
    onOk = props.onOk,
    onBlur = props.onBlur,
    onFocus = props.onFocus,
    onChange = props.onChange,
    value = props.value,
    sendId = props.sendId,
    _props$useType = props.useType,
    useType = _props$useType === void 0 ? 'default' : _props$useType,
    captchaWrapClassName = props.captchaWrapClassName;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    clock = _useState2[0],
    setClock = _useState2[1];
  var intervalRef = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)('免费获取验证码'),
    _useState4 = _slicedToArray(_useState3, 2),
    codeTxt = _useState4[0],
    setCodeTxt = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    validateCaptcha = _useState6[0],
    setValidateCaptcha = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    visibleCaptcha = _useState8[0],
    setVisibleCaptcha = _useState8[1];
  var handleValidateCaptcha = function handleValidateCaptcha() {
    (0, _login.getBusinessList)().then(function (res) {
      if (!res.success) {
        _message2.default.error('获取验证信息失败');
        return;
      }
      var bool = res.data[sourceType];
      setValidateCaptcha(bool);
    });
  };
  (0, _react.useEffect)(function () {
    handleValidateCaptcha();
  }, []);
  var handleCaptchaSubmit = function handleCaptchaSubmit(props) {
    // 关闭验证码
    setVisibleCaptcha(false);
    handleSendMsg(_objectSpread({
      account: account,
      messageParam: messageParam,
      sourceType: sourceType,
      bid: bid
    }, props));
  };
  /**
   * 发送
   */
  var handleClick = function handleClick() {
    if (onValid && !onValid()) {
      return;
    }
    if (validateCaptcha) {
      setVisibleCaptcha(true);
    } else {
      handleSendMsg({
        account: account,
        messageParam: messageParam,
        sourceType: sourceType
      });
    }
  };
  var handleSendMsg = function handleSendMsg(param) {
    setCodeTxt('发送中...');
    var requestApi = useType === 'default' ? _login.sendMsg : _login.gameSendMsg;
    requestApi(_objectSpread({}, param)).then(function (res) {
      if (!res.success) {
        onError && onError(res);
        setCodeTxt('免费获取验证码');
        return;
      }
      var data = JSON.parse(res.data);
      if (_typeof(data) !== 'object') {
        return;
      }
      var countDownTime = data.Data.CountDownTime;
      if ([_login2.SEND_MSG_STATUS.success, _login2.SEND_MSG_STATUS.sendSuccess].includes(data.Status)) {
        // 发送成功
        countDown(countDownTime);
      } else if (data.Status === _login2.SEND_MSG_STATUS.timeFailed) {
        // 未达到下次发送时间
        if (countDownTime !== 0) {
          countDown(countDownTime);
        }
      } else if ([_login2.SEND_MSG_STATUS.numFailed, _login2.SEND_MSG_STATUS.infoFailed].includes(data.Status)) {
        //次数太多 || 获取信息失败
        countDown(_consts.MINUTE);
        var response = {
          message: data.Message
        };
        onError && onError(response);
      } else {
        onError && onError(res);
      }
    }, function (error) {});
  };
  /**
   * 倒计时
   * @param time
   */
  var countDown = function countDown(time) {
    onOk && onOk(time);
    var t = time;
    intervalRef.current = setInterval(function () {
      if (0 < t) {
        t--;
        setClock(t);
        setCodeTxt(t ? "".concat(t, "\u79D2\u540E\u53EF\u91CD\u65B0\u83B7\u53D6") : '重新获取');
      } else {
        // 倒计时结束
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        setClock(0);
        setCodeTxt('重新获取');
        onOk && onOk(0);
      }
    }, _consts.DURATION);
  };
  /**
   * 清除倒计时
   */
  (0, _react.useEffect)(function () {
    return function () {
      return clearInterval(intervalRef.current);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_send_msg_wrap', className, typeMsg === 'login' ? 'gy_login_send_msg_wrap' : 'gy_default_send_msg_wrap')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_send_msg_merge"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_send_msg_item"
  }, prefix && /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_send_msg_icon"
  }), /*#__PURE__*/_react.default.createElement(_input.default, {
    className: "gy_send_msg_input",
    placeholder: placeholder,
    autoComplete: "off",
    maxLength: MAX_LENGTH,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    id: id,
    value: value
  })), /*#__PURE__*/_react.default.createElement(_button.default, {
    className: "gy_send_msg_btn",
    id: sendId,
    onClick: function onClick() {
      return handleClick();
    },
    disabled: disabled || clock !== 0 || codeTxt === '发送中...'
  }, codeTxt)), validateCaptcha && /*#__PURE__*/_react.default.createElement(_Captcha.default, {
    bId: bid || '',
    visible: visibleCaptcha,
    onSubmit: handleCaptchaSubmit,
    onClose: function onClose() {
      return setVisibleCaptcha(false);
    },
    wrapClassName: captchaWrapClassName
  }));
};
var _default = Index;
exports.default = _default;